export default __webpack_public_path__ + "static/media/commoditiesImg.20c99c63.webp";